import React from 'react'
// import { Card, CardMedia, CardTitle } from 'material-ui/Card'
import Card, { CardMedia, CardContent } from 'material-ui-next/Card'
import Typography from 'material-ui-next/Typography'
import { getCategoryCardImage } from '../utils'
import withStyles from 'material-ui-next/styles/withStyles'

const styles = {
  container: {
    margin: 'auto',
    minHeight: 250,
    marginBottom: 10,
  },
  image: {
    position: 'relative',
    minHeight: 250,
  },
  overlay: {
    display: 'flex',
    alignItems: 'center',
    height: '80px',
    padding: '16px',
    color: 'rgba(255, 255, 255, 0.87)',
    fontSize: '18px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
  },
}

const CategoryCard = ({ category, classes }) => (
  <Card className={classes.container}>
    <CardMedia
      className={classes.image}
      image={getCategoryCardImage(category.mondo, category.slug)}
      title={category.nome}>
      <div className={classes.overlay}>
        {category.nome}
      </div>
    </CardMedia>
    {/* <CardContent style={{ opacity: '0.2' }}>
       </CardContent> */}
    {/* <CardMedia
      overlayContentStyle={{ height: '80px' }}
      overlay={
        <CardTitle
          titleStyle={{ lineHeight: '24px', fontSize: '18px' }}
          title={category.nome}
        />
      }>
      <img
        alt={category.nome}
        style={styles.image}
        src={getCategoryCardImage(category.mondo, category.slug)}
      />
    </CardMedia> */}
  </Card>
)

export default withStyles(styles)(CategoryCard)



// WEBPACK FOOTER //
// ./src/common/CategoryCard.js